webpackJsonp([88245472118650],{

/***/ 350:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Gatsby + Netlify CMS Starter"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/blog/2017-01-04-just-in-small-batch-of-jamaican-blue-mountain-in-store-next-week/"},"frontmatter":{"title":"Introduction"}}}]}},"pathContext":{"tag":"intro"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-intro-99a50e961d1bb8c89682.js